export default "__VITE_PUBLIC_ASSET__687b5f14__"